import { render, staticRenderFns } from "./TabDadosUsuario.vue?vue&type=template&id=3e723fdc&scoped=true&"
import script from "./TabDadosUsuario.vue?vue&type=script&lang=js&"
export * from "./TabDadosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabDadosUsuario.vue?vue&type=style&index=0&id=3e723fdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e723fdc",
  null
  
)

export default component.exports